import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as fileMgmt from '../../../../../file-mgmt'
import type { Group } from '../../../group'
import type { Api } from '../../api'
import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import * as extraReducers from './extra-reducers'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Plugin for sending agent messages
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create('AgentMessageSender')
  /** @see {@link Api} */
  public readonly api: Api
  /** @see {@link Group} */
  public readonly assistantGroup: Group

  constructor({
    api,
    assistantGroup,
    collection,
  }: Readonly<Plugin.constructor.Params>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })

    this.api = api
    this.assistantGroup = assistantGroup

    this.feature.registerExtraReducers(
      extraReducers.dropInfoEntriesOnContextChange(this),
    )
    this.feature.registerEffects(
      effects.sendMessage(this, ngCore.inject(fileMgmt.Feature)),
      effects.addMessageOnRequest(this),
      effects.retryMessage(this),
      effects.applyPublishedMessages(this),
      effects.applyPublishedInfoEntries(this),
      effects.restoreUnlistedMessages(this),
    )
  }
}

export namespace Plugin {
  export namespace constructor {
    export interface Params {
      api: Api
      assistantGroup: Group
      collection: ec.Collection<TypeParams>
    }
  }
}
